import cn from 'classnames'

import { CLASSES, COLOR, type ColorToken } from '../../theme/tailwindTokens'
import { variants } from './variants'

export type WaveDirection = 'down' | 'up'

export type WaveProps = {
  direction?: WaveDirection | ''
  peakCount?: 0 | 2 | 3
  className?: string
  color?: ColorToken
  height?: 0 | 5 | 10 | 15 | 20
}

export function Wave({
  direction = '',
  peakCount = 0,
  className = '',
  color = COLOR.cornflower,
  height = 0,
}: WaveProps) {
  if (!direction || !peakCount) return null

  const name = `${direction}${peakCount}`
  const Variant = variants[name]

  if (!Variant) {
    console.error(`The Wave '${name}' does not exist.`)
    return null
  }

  const containerClasses = cn(className, 'w-screen -z-50 absolute', {
    'top-0': direction === 'down',
    'bottom-0': direction === 'up',
  })

  const waveClasses = cn(CLASSES.fill(color), {
    '-translate-y-px': direction === 'down',
    'translate-y-px': direction === 'up',
  })

  const fillClasses = cn(CLASSES.bg(color), {
    'h-[5dvh]': height === 5,
    'h-[10dvh]': height === 10,
    'h-[15dvh]': height === 15,
    'h-[20dvh]': height === 20,
  })

  return (
    <div className={containerClasses} aria-hidden='true'>
      {direction === 'down' ? <div className={fillClasses} /> : null}
      <Variant className={waveClasses} />
      {direction === 'up' ? <div className={fillClasses} /> : null}
    </div>
  )
}
